import { ItemType } from '@bamboohr/fabric';
import { isEnabled } from '@bamboohr/utils/lib/feature';

/**
 * Takes an Array of ItemTypes for the Tax Type field and groups the items by their `note` field
 *
 * @param options an array of ItemTypes
 * @returns select's ItemTypes
 */
export function selectTaxTypeOptionsConverter(options: Array<ItemType>) {
	if (!isEnabled('OWNER_AND_CORPORATE_OFFICER_TAX_TYPE_FILTER_UPDATES')) {
		return options;
	}

	const groups = new Map<string, Array<ItemType>>();

	for (const { note, ...option } of options) {
		const key = typeof note === 'string' ? note : '';
		let group = groups.get(key);
		if (!group) {
			group = [];
			groups.set(key, group);
		}
		group.push(option);
	}

	const selectItems: Array<ItemType> = [];

	for (const [groupName, items] of groups) {
		if (groupName) {
			selectItems.push({
				text: groupName,
				value: groupName,
				type: 'group',
				items,
			});
		} else {
			selectItems.push(...items);
		}
	}

	return selectItems;
}
